import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiBenefitsQueryResponse,
  GetApiBenefitsQueryParams,
  GetApiBenefits401,
  GetApiBenefits403,
} from "../../../types/GetApiBenefits";

export function getGetApiBenefitsUrl() {
  return `/api/Benefits` as const;
}

/**
 * {@link /api/Benefits}
 */
export async function getApiBenefits(
  params?: GetApiBenefitsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiBenefitsQueryResponse,
    ResponseErrorConfig<GetApiBenefits401 | GetApiBenefits403>,
    unknown
  >({
    method: "GET",
    url: getGetApiBenefitsUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
